export default {"src":"/_next/static/media/modern-kitchen.b974c675.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};